import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Empathy from './components/Empathy';
import ServiceDefinition from './components/ServiceDefinition';
import Features from './components/Features';
import ServiceAreas from './components/ServiceAreas';
import Pricing from './components/Pricing';
import BottomCTA from './components/BottomCTA';
import Footer from './components/Footer';
import Header from './components/Header';
import SeoJsonLd from '../../components/SeoJsonLd';
import {
  getOrganizationSchema,
  getLocalBusinessSchema,
  getServiceSchema,
  getFAQSchema,
  getWebPageSchema,
  getBreadcrumbSchema
} from '../../utils/seoData';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const jsonLdData = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      getLocalBusinessSchema(),
      getServiceSchema(),
      getFAQSchema(),
      getWebPageSchema(),
      getBreadcrumbSchema()
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd data={jsonLdData} />
      <Header isScrolled={isScrolled} />
      <Hero />
      <Empathy />
      <ServiceDefinition />
      <Features />
      <ServiceAreas />
      <Pricing />
      <BottomCTA />
      <Footer />
    </div>
  );
}
